
import React from 'react';
import Highlight from './ui/Highlight.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBicycle, faBolt, faTag } from '@fortawesome/free-solid-svg-icons';

const Highlights = () => {
    
  return (
    <section id="highlights">
        <div className="container">
            <div className="row">
                <h2 data-aos='' data-aos-duration="3000" className="section__title">
                    Why choose <span className="purple">the Bike Shop</span>
                </h2>

                <div data-aos='' data-aos-duration="3000" className="highlight__wrapper">
                <Highlight 
                        icon={ <FontAwesomeIcon icon={faBolt} /> }
                        title="Easy and Quick"
                        para="Get access to any bicycles you can purchase online." 
                    />

                    <Highlight 
                        icon={ <FontAwesomeIcon icon={faBicycle} /> }
                        title="10,000+ Bicycles"
                        para="Get accessed to over 10,000 bicycles available." 
                    />

                    <Highlight 
                        icon={ <FontAwesomeIcon icon={faTag} /> }
                        title="Affordable"
                        para="Get your hands on popular bicycles for as little as $500+." 
                    />

                </div>
            </div>
        </div>
    </section>
  )
}

export default Highlights;